import React from "react";
import { Award, MapPin, Home } from "lucide-react";

const RankingDisplay = ({ rankingData }) => {
  const formatRank = (rank) => {
    if (!rank || rank < 1) return "N/A";
    const j = rank % 10;
    const k = rank % 100;

    if (j === 1 && k !== 11) return `${rank}st`;
    if (j === 2 && k !== 12) return `${rank}nd`;
    if (j === 3 && k !== 13) return `${rank}rd`;
    return `${rank}th`;
  };

  return (
    <div className="bg-white rounded-xl p-3 sm:p-4 shadow-md w-full max-w-[320px] sm:max-w-md mx-auto">
      <h2 className="text-gray-600 font-medium text-center mb-3 sm:mb-4 text-sm sm:text-base">
        Your Ranking
      </h2>

      <div className="flex justify-between items-center gap-2 sm:gap-3">

        {/* STATE RANK */}
        <div className="bg-yellow-50 rounded-lg p-2 sm:p-3 flex flex-col items-center flex-1 min-w-0">
          <div className="flex items-center text-yellow-500 mb-1">
            <Award className="w-5 h-5" />
          </div>
          <span className="text-lg font-bold text-gray-800">
            {formatRank(rankingData?.stateRank)}
          </span>
          <span className="text-xs text-gray-400">
            of {rankingData?.stateTotal ?? "N/A"}
          </span>
          <p className="text-xs font-medium text-gray-500">State Rank</p>
        </div>

        {/* DISTRICT RANK */}
        <div className="bg-blue-50 rounded-lg p-2 sm:p-3 flex flex-col items-center flex-1 min-w-0">
          <div className="flex items-center text-blue-500 mb-1">
            <MapPin className="w-5 h-5" />
          </div>
          <span className="text-lg font-bold text-gray-800">
            {formatRank(rankingData?.districtRank)}
          </span>
          <span className="text-xs text-gray-400">
            of {rankingData?.districtTotal ?? "N/A"}
          </span>
          <p className="text-xs font-medium text-gray-500">District Rank</p>
        </div>

        {/* TALUK RANK */}
        <div className="bg-green-50 rounded-lg p-2 sm:p-3 flex flex-col items-center flex-1 min-w-0">
          <div className="flex items-center text-green-500 mb-1">
            <Home className="w-5 h-5" />
          </div>
          <span className="text-lg font-bold text-gray-800">
            {formatRank(rankingData?.talukRank)}
          </span>
          <span className="text-xs text-gray-400">
            of {rankingData?.talukTotal ?? "N/A"}
          </span>
          <p className="text-xs font-medium text-gray-500">Taluk Rank</p>
        </div>
      </div>
    </div>
  );
};

export default RankingDisplay;
